import { render, staticRenderFns } from "./ProgramAdminLog.vue?vue&type=template&id=a3d2f284&lang=pug&"
import script from "./ProgramAdminLog.vue?vue&type=script&lang=js&"
export * from "./ProgramAdminLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports